import { getAccessToken, redirectToLoginOnUnauthorized } from "./auth"
import { config } from "./config"

export const getAuthHeaders = (): HeadersInit => {
  const token = getAccessToken()
  return token ? { Authorization: `Bearer ${token}` } : {}
}

const baseUrl = () => config.apiUrl

export const apiFetch = async <T>(path: string, init: RequestInit = {}): Promise<T> => {
  const headers = new Headers(init.headers)
  const auth = getAuthHeaders()
  Object.entries(auth).forEach(([k, v]) => headers.set(k, v))
  if (!headers.has("Content-Type") && init.body && !(init.body instanceof FormData)) {
    headers.set("Content-Type", "application/json")
  }
  const response = await fetch(`${baseUrl()}${path}`, { ...init, headers })
  if (response.status === 401) {
    redirectToLoginOnUnauthorized()
    throw new Error("Não autenticado")
  }
  if (!response.ok) {
    const detail = await response.text()
    throw new Error(detail || `HTTP ${response.status}`)
  }
  if (response.status === 204) {
    return undefined as T
  }
  return response.json() as Promise<T>
}

export type Empresa = {
  id: string
  cnpj: string
  razao_social: string
  nome_fantasia: string | null
  uf: string
  organizacao_id: string
}

export type MeResponse = {
  email: string | null
  must_change_password: boolean
  is_super_admin: boolean
  is_gestor: boolean
  organizacao_ids: string[]
  papeis: string[]
}

export const fetchMe = () => apiFetch<MeResponse>("/v1/me")
export const fetchEmpresas = () => apiFetch<Empresa[]>("/v1/me/empresas")
